import type { DecoBuildCtx } from "./define.ts";
import { shade, rand } from "../color.ts";

// Dock hanging net between two posts — diamond mesh of thin rods.
const build: (ctx: DecoBuildCtx) => void = ({ box, rod, seed }) => {
  const wood = shade(0x6b5334, (rand(seed) - 0.5) * 0.1);
  const cord = shade(0xc8b898, (rand(seed + 1) - 0.5) * 0.08);
  box(-0.9, 0.9, 0, 0.12, 1.8, 0.12, wood);
  box(0.9, 0.9, 0, 0.12, 1.8, 0.12, wood);
  box(0, 1.7, 0, 1.9, 0.1, 0.1, wood);
  box(0, 0.35, 0, 1.9, 0.1, 0.1, wood);
  // Coarse net grid
  for (let i = 0; i < 5; i++) {
    const t = i / 4;
    const x = -0.75 + t * 1.5;
    rod(x, 0.4, 0, x, 1.65, 0, 0.018, cord);
  }
  for (let j = 0; j < 4; j++) {
    const t = j / 3;
    const y = 0.5 + t * 1.05;
    rod(-0.75, y, 0, 0.75, y, 0, 0.018, cord);
  }
  // Diagonal accents
  rod(-0.75, 0.45, 0, 0.75, 1.55, 0, 0.015, shade(cord, -0.08));
  rod(-0.75, 1.55, 0, 0.75, 0.45, 0, 0.015, shade(cord, -0.08));
};

export default build;
